import React from 'react';

const PageHeader: React.FC = () => {
  return (
    <header className="flex h-14 items-center border-0 border-b border-solid border-[#d1d5db] bg-gradient-to-r from-[#c7e7ff] to-[#9fd1ff] px-6">
      <div className="flex h-full items-center text-[18px] font-semibold text-[#1f2937]">
        EBP系统EAC智能化提升
      </div>
    </header>
  );
};

export default PageHeader;
